export default __webpack_public_path__ + "static/beatbugs-6-c08ccf96c442db6df1286d4b535800a4.webp";